import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ILocumJobs } from '../../models/dashboard/jobs/getLocumJobs.model';

// 1) define the shape of a single invitation record
export interface IInvitedJob {
  id: string;
  job: ILocumJobs;
  invitedUserId: string;
  invitedBy: string;
  viewed: boolean;
  status: string;      // e.g. "PENDING" | "ACCEPTED" | …
  createdAt: string;   // ISO timestamp
}

interface IInvitedJobsState {
  page: number;
  perPage: number;
  totalPages: number;
  totalElements: number;
  numberOfElements: number;
  first: boolean;
  last: boolean;
  invitedJobs: IInvitedJob[];    // <-- use the new interface here
}

const initialState: IInvitedJobsState = {
  page: 1,
  perPage: 10,
  totalPages: 0,
  totalElements: 0,
  numberOfElements: 0,
  first: true,
  last: true,
  invitedJobs: [],
};

// 2) your API payload now has a `content: IInvitedJob[]` field
interface IInvitedJobsResponsePayload {
  page: number;
  perPage: number;
  totalPages: number;
  totalElements: number;
  numberOfElements: number;
  first: boolean;
  last: boolean;
  content: IInvitedJob[];        // <-- renamed from `invitedJobs`
}

const invitedJobsSlice = createSlice({
  name: 'invitedJobs',
  initialState,
  reducers: {
    updateInvitedJobs(
      state,
      action: PayloadAction<IInvitedJobsResponsePayload>
    ) {
      const {
        page,
        perPage,
        totalPages,
        totalElements,
        numberOfElements,
        first,
        last,
        content,                // <-- the array of full invite objects
      } = action.payload;

      state.page = page;
      state.perPage = perPage;
      state.totalPages = totalPages;
      state.totalElements = totalElements;
      state.numberOfElements = numberOfElements;
      state.first = first;
      state.last = last;
      state.invitedJobs = content; // <-- assign the new invite array
    },
  },
});

export const invitedJobsActions = invitedJobsSlice.actions;
export default invitedJobsSlice.reducer;
